<template>
    <div class="foott-batb-pay">
        <el-dialog
            title=""
            width="500px"
            class="repair-dialog"
            :visible.sync="dialogHide"
            :before-close="gotoProductFootBath"
        >
            <div class="dialog-mains p10">
                <el-image class="img" :src="successImg"></el-image>
                <p class="money" v-if="status == 1">登记成功</p>
                <p class="money" v-else>修护完成</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="btn" type="primary" @click="gotoProductFootBath">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import minxin from '../../../assets/javascript/minxin.js'
import {decrypt,encrypt} from '../../../assets/javascript/untils'
export default {
    mixins: [minxin],
    props: {
        hintName:{
            type: String,
            default: null,
        },
        status: {
            type: Number,
            default: null,
        }
    },
    data () {
        return {
            form: {},
            orderId: '',
            dialogHide: false,
            headImg: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
            payWayList: [],
            parentForm: {},
            successImg: require('../../../assets/images/money/success.png'),
            mainHeight: this.$store.getters.MainHeight
        }
    },
    created(){
    },
    mounted(){
        this.init();
    },
    methods: {
        handleClose(){
            this.dialogHide = false;
        },
        init(){
            this.$on('set',function(id){
                this.orderId = id;
                this.dialogHide = true;
            })
        },
        gotoOrderInfo(){
            if(this.$route.params.id != 'false'){
                window.open(this.$router.resolve(`/orderInfo/${this.orderId}`).href, '_blank');
            } else {
                window.open(this.$router.resolve(`/orderInfo`).href, '_blank');
            }
        },
        gotoProductFootBath(){
            // this.$router.push(`/collectMoney`);
            this.$emit("payChang",true)
            this.dialogHide = false;
        },
    }
}
</script>

<style scoped lang="less">
@import '../../../assets/css/edit.less';
/deep/ .el-dialog{
    margin-top: 0 !important;
    height: 350px;
    top: calc(50% - 175px);
}
/deep/ .el-dialog__header {
    height: 50px;
    box-sizing: border-box;
    padding: 0;
    line-height: 50px;
    text-align: center;
    font-size: .18rem;
    .el-dialog__title{
        color: #fff;
    }
    .el-dialog__headerbtn {
        top: 13px;
        .el-dialog__close {
            color: #666;
            border: 1px solid #666;
            border-radius: 50%;
            padding: 2px;
            &:hover{
                color: @blue;
                border: 1px solid @blue;
                background: #fff;
            }
        }
    }
}
/deep/ .el-dialog__body{
    padding: .2rem 0;
    display: flex;
    justify-content: center;
    
    .money{
        font-size: .18rem;
        color: #333;
        font-weight: bold;
        text-align: center;
    }
}

/deep/ .el-dialog__footer{
    text-align: center;
    .btn{
        font-size: .18rem;
        width: 155px;
        height: 55px;
    }
    .normal-btn{
        margin-right: 50px;
    }
}
</style>